// extracted by mini-css-extract-plugin
module.exports = {"link":"ApplyLink_link__5mpNG","uppercase":"ApplyLink_uppercase__NdI5Q"};